<mat-card appearance="outlined"
          [@cardState]>
  <mat-card-header flex
                   layout-align="space-between center">
    <mat-card-title [translate]="'global.tagSettings'"
                    class="padding-left-0">Tag Settings</mat-card-title>
    <div class="padding-right-7px">
      <button mat-icon-button
              (click)="onNoClick()">
        <mat-icon class="icon-clear">clear</mat-icon>
      </button>
    </div>
  </mat-card-header>
  <mat-card-content>
    @if (isLoadingTags) {
    <div class="progress-spinner-container">
      <mat-spinner class="progress-spinner"
                   strokeWidth="10"
                   [diameter]="150"></mat-spinner>
    </div>
    } @else {
    <div cdkDropList
         class="example-list"
         (cdkDropListDropped)="onDrop($event)"
         [cdkDropListAutoScrollDisabled]="false"
         [cdkDropListAutoScrollStep]="50">
      @for (tag of tagsList; let tagIndex = $index; track tag.id) {
      <div class="example-box"
           flex
           layout="row"
           layout-align="space-between center"
           cdkDrag
           [cdkDragDisabled]="disableDrag"
           (mousedown)="onMouseDown()"
           (mouseup)="onMouseUp()">
        <div flex
             layout="row"
             layout-align="start center">
          <mat-icon>reorder</mat-icon>
          <div flex
               class="row-inset-padding"
               [ngStyle]="{'color': tag.color}">
            {{tag.name}}
          </div>
        </div>
        @if (tag.description) {
        <div class="tag-description"
             itfgOverflowTooltip
             matTooltip
             [tooltipText]="tag.description"
             [tooltipPosition]="'above'">
          {{tag.description}}
        </div>
        }
        <mat-slide-toggle [checked]="!!tag.visible"
                          (click)="$event.stopPropagation()"
                          (mousedown)="onMouseDown()"
                          (mouseup)="onMouseUp()"
                          (change)="onTagVisibilityChange(tag.id, $event)"
                          [matTooltip]="!tag.visible ? ('tags.showTag' | translate) : ('tags.hideTag' | translate)"
                          matTooltipPosition="above">
        </mat-slide-toggle>
      </div>
      }
    </div>

    <div class="tag-buttons">
      <button type="button"
              mat-raised-button
              color="primary"
              class="tag-action-item"
              (click)="resetTags()">
        <span [translate]="'tags.resetTagSettings'">Reset tag settings to standard order</span>
      </button>
    </div>
    }
  </mat-card-content>
</mat-card>
